import React from "react";

import Reveal from "./Reveal";
import SectionTag from "./SectionTag";

//Section tag + heading with the original site's entrance effects: the tag wipes in, the heading floats in from the left
const SectionHeading = ({ tag, title, className = "" }) => (
  <div className={`section-heading ${className}`}>
    <Reveal
      as={"div"}
      variant={"wipe"}
      className={"section-tag-reveal"}
    >
      <SectionTag>{tag}</SectionTag>
    </Reveal>
    <Reveal
      as={"h2"}
      variant={"float"}
      className={"section-title"}
    >
      {title}
    </Reveal>
  </div>
);

export default SectionHeading;
